import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { ITheme } from '../../../../../ui';
import { BookingDetails } from './BookingDetails';
import { StyledParkingProductRow } from './BookingDetailsTable';
import { useCurrentBookingReference } from './helpers/useCurrentBookingReference';
import { BookingDetailsShimmer } from './BookingDetailsShimmer';
import { BookingDetailsNotFound } from './BookingDetailsNotFound';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { DialogHeader, DialogMain } from '../../../../shared/components/dialog';
import { useMyBookingsStore } from '../../../domain/booking/stores/useMyBookingsStore';
import { StyledBookingDetailsCell } from '../../booking/BookingDetailsTable';
import themed from '../../../../../ui/themer/themed';

export const BookingDetailsDialog = observer(() => {
	const { t } = useTranslation();
	const myBookingsStore = useMyBookingsStore();
	const reference = useCurrentBookingReference();
	const booking = myBookingsStore.findBookingByReference(reference);
	const { isLoading } = myBookingsStore;

	return (
		<>
			<DialogHeader title={t('parking_booking_details_header')} />
			<StyledDialogMain>
				{booking ? (
					<BookingDetails booking={booking} />
				) : isLoading ? (
					<BookingDetailsShimmer />
				) : (
					<BookingDetailsNotFound />
				)}
			</StyledDialogMain>
		</>
	);
});

/** Workaround for creating a full-width solid background for the Parking Product table row */
const StyledDialogMain = styled(DialogMain)<{}, ITheme>`
	${StyledParkingProductRow} {
		${StyledBookingDetailsCell} {
			position: relative;

			&:first-of-type:before,
			&:last-of-type:after {
				content: '';
				position: absolute;
				top: 0;
				bottom: 0;
				width: 50vw;
				background: ${themed(({ background }) => background.light)};
			}

			&:first-of-type:before {
				left: -50vw;
			}

			&:last-of-type:after {
				right: -50vw;
			}
		}
	}
`;
